import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';

import qs from 'query-string';
import {
  API_ENDPOINT,
  type CourseType,
  useClientApiV1VouchersMyUpcomingEventsQuery,
} from '../../resources/@types/courseSchema';

interface UseClientV1VouchersMyUpcomingEventsQuery {
  options?: Parameters<typeof useClientApiV1VouchersMyUpcomingEventsQuery>[0]['options'];
  courseType: CourseType;
  lang?: string;
}

export function useVouchersMyUpcomingEventsQuery({
  options,
  courseType,
}: UseClientV1VouchersMyUpcomingEventsQuery) {
  return useClientApiV1VouchersMyUpcomingEventsQuery({
    queryKey: getVouchersMyUpcomingEventsQueryKey({ courseType }),
    url: getVouchersMyUpcomingEventsUrl({ courseType }),
    options,
  });
}

export const getVouchersMyUpcomingEventsQueryKey = ({
  courseType,
}: {
  courseType: CourseType;
  lang?: string;
}): QueryKeyReturnType => [API_ENDPOINT.CLIENT_V1_VOUCHERS_MY_UPCOMING_EVENTS, courseType];

export const getVouchersMyUpcomingEventsUrl = ({
  courseType,
}: {
  courseType: CourseType;
}): string =>
  qs.stringifyUrl(
    {
      url: API_ENDPOINT.CLIENT_V1_VOUCHERS_MY_UPCOMING_EVENTS,
      query: {
        courseType,
      },
    },
    { skipEmptyString: true },
  );
